import { Box, Divider, Flex, styled } from "styled-system/jsx";
import { Text, Switch } from "@ttc3k/trekker";
import { PropsWithChildren } from "react";
import { Collapsible } from "shared/components/molecules";

const CardContainer = styled(Flex, {
  base: {
    borderRadius: "100",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "border.light",
    outlineWidth: "1px",
    outlineStyle: "solid",
    outlineColor: "transparent",
    py: "250",
    px: "300",
    bg: "white",
    flexDirection: "column",
  },
});

type ExpandableSwitchCardProps = PropsWithChildren & {
  title: string;
  isSelected: boolean;
  onToggleSwitch: () => void;
};

export const ExpandableSwitchCard = ({
  isSelected,
  onToggleSwitch,
  title,
  children,
}: ExpandableSwitchCardProps) => {
  return (
    <CardContainer>
      <Flex justifyContent={"space-between"} alignItems={"center"} gap={"400"}>
        <Text visual={"bodySemiBold"} color={"text.dark"}>
          {title}
        </Text>
        <Switch checked={isSelected} onCheckedChange={onToggleSwitch} />
      </Flex>
      <Collapsible open={isSelected}>
        <Box w={"full"} pt={"300"}>
          <Divider w={"full"} borderColor={"border.light"} />
          {children}
        </Box>
      </Collapsible>
    </CardContainer>
  );
};
